<div class="flex-direction-column height-100 page">
  <div class="flex-direction-row justify-between align-center">
    @if (grupos.length > 0) {
      <app-form-field style="margin-right: 1%" placeholder="Pesquisar" iconPrefix="search" iconColor="var(--primary)" backgroundColor="transparent" classe="pesquisar"
                      widthFormField="325px" heightFormField="35px" borderColor="var(--primary)" (changeValue)="filtrarGrupos($event)"></app-form-field>
    }
  </div>

  @if (grupos.length > 0) {
    <mat-table [dataSource]="gruposDataSource">
      <ng-container matColumnDef="acao">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let elemento">
          <div class="flex-direction-row gap-5">
            <app-button-padrao iconSrc="icones/edit" iconSrcExtensao=".svg" width="30px" height="30px" backgroundColor="transparent"
                               widthIcon="22px" heightIcon="22px" (buttonClick)="abrirModal(false, elemento)"></app-button-padrao>
            <app-button-padrao iconSrc="icones/visualizar" iconSrcExtensao=".svg" width="30px" height="30px" backgroundColor="transparent"
                               widthIcon="20px" heightIcon="20px" (buttonClick)="abrirModal(true, elemento)"></app-button-padrao>
          </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="logo">
        <mat-header-cell *matHeaderCellDef> Logo </mat-header-cell>
        <mat-cell *matCellDef="let elemento">
          @if (elemento.logoExtensao && elemento.uuid) {
            <img [src]="gerarUrl(elemento.uuid, elemento.logoExtensao, 'grupo-logo')" style="height: 25px;" alt="Logo do grupo" />
          } @else {
            <img src="./assets/icones/no-img-default.png" style="width: 25px; height: 25px" alt="" />
          }
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="nome">
        <mat-header-cell *matHeaderCellDef> Nome </mat-header-cell>
        <mat-cell *matCellDef="let elemento"> <span class="ellipse" [matTooltip]="elemento.nome">{{ elemento.nome }}</span> </mat-cell>
      </ng-container>

      <ng-container matColumnDef="nomeResponsavel">
        <mat-header-cell *matHeaderCellDef> Responsável </mat-header-cell>
        <mat-cell *matCellDef="let elemento"> <span class="ellipse" [matTooltip]="elemento.responsavel.nome">{{ elemento.responsavel.nome }}</span></mat-cell>
      </ng-container>

      <ng-container matColumnDef="emailResponsavel">
        <mat-header-cell *matHeaderCellDef> E-mail Responsável </mat-header-cell>
        <mat-cell *matCellDef="let elemento">
          <span class="ellipse" [matTooltip]="elemento.responsavel.email">
            {{ elemento.responsavel.email }}
          </span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="qtdUsuario">
        <mat-header-cell *matHeaderCellDef> Qtd Usuários </mat-header-cell>
        <mat-cell *matCellDef="let elemento"> {{elemento.quantidadeDeUsuarios}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="ativo">
        <mat-header-cell *matHeaderCellDef> Status </mat-header-cell>
        <mat-cell *matCellDef="let elemento"> {{elemento.ativo ? 'Ativo' : 'Inativo'}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="usuCriacao">
        <mat-header-cell *matHeaderCellDef> Usu. Criação </mat-header-cell>
        <mat-cell *matCellDef="let elemento"> <span class="ellipse" [matTooltip]="elemento.usuarioCriacao">{{ elemento.usuarioCriacao }}</span> </mat-cell>
      </ng-container>

      <ng-container matColumnDef="dataCriacao">
        <mat-header-cell *matHeaderCellDef> Data Criação </mat-header-cell>
        <mat-cell *matCellDef="let elemento"> {{ elemento.dataCriacao | date:'dd/MM/yyyy - HH:mm' }} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="usuAlteracao">
        <mat-header-cell *matHeaderCellDef> Usu. Alteração </mat-header-cell>
        <mat-cell *matCellDef="let elemento"> <span class="ellipse" [matTooltip]="elemento.usuarioAlteracao">{{ elemento.usuarioAlteracao }}</span> </mat-cell>
      </ng-container>

      <ng-container matColumnDef="dataAlteracao">
        <mat-header-cell *matHeaderCellDef> Data Alteração </mat-header-cell>
        <mat-cell *matCellDef="let elemento"> {{ elemento.dataAlteracao | date:'dd/MM/yyyy - HH:mm' }} </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table>
  }
  @else if (gruposCarregados){
    <div class="flex center-center height-100">
      <img style="height: 394px; width: 582px;" src="./assets/imagem-mulher-nao-eh-bug.png" alt="">
    </div>
  }

  <img src="./assets/botao-add.svg" class="botao-add cursor-pointer" alt="Adicionar grupo" role="button" tabindex="0" (click)="abrirModal(false)" (keydown.enter)="abrirModal(false)" />
</div>
